<section class="main-content profile-content">
  <div class="container">
    <div class="caption">
      <h1 class="mb-3">{{config?.heading}} Safety Induction Pass</h1>
      <h2 *ngIf="inductionProfile && (!showAcknowledgeButton || inductionProfile?.status === 'Acknowledged')"
        class="mb-2" [ngClass]="{'validpass': isValidPass, 'invalidpass' : !isValidPass }">
        {{isValidPass ? 'VALID': 'EXPIRED'}}
      </h2>

      <!-- Acknowledgement Status Messages -->
      <div *ngIf="acknowledgementComplete" class="alert alert-success text-center mt-3">
        <i class="fas fa-check-circle"></i>
        <strong>Acknowledged Successfully!</strong> This safety induction has been approved.
      </div>

      <div *ngIf="acknowledgementError" class="alert alert-danger text-center mt-3">
        <i class="fas fa-exclamation-triangle"></i>
        <strong>Error:</strong> {{ acknowledgementError }}
      </div>
    </div>

    <form *ngIf="inductionProfile">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-5 col-md-5">
              <div class="row">
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Site:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control" [value]="inductionProfile.site" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Name:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control" [value]="inductionProfile.name" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Mobile No:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control" [value]="inductionProfile.mobileNo" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Email:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="email" class="form-control" [value]="inductionProfile.email" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-7 col-md-7">
              <div class="row">
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Company Name:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control" [value]="inductionProfile.company" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Position:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control" [value]="inductionProfile.position" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Visit Date:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control"
                        value="{{inductionProfile.visitDateTime | date:'MMM d, y hh:mm a' }}" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Purpose of Visit:</label>
                    </div>
                    <div class="col-md-8">
                      <textarea class="form-control" [value]="inductionProfile.purposeOfVisit" rows="3"
                        readonly></textarea>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-6">
                  <div class="row align-items-center form-group">
                    <div class="col-md-4">
                      <label>Expiry Date:</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control"
                        value="{{inductionProfile.expiryDate | date:'MMM d, y hh:mm a' }}" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="caption">
        <h3 class="text-center my-3">Site Contact</h3>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-5 col-md-5">
              <div class="row align-items-center form-group">
                <div class="col-md-4">
                  <label>Contact on site:</label>
                </div>
                <div class="col-md-8">
                  <input type="text" class="form-control" [value]="inductionProfile.alecContactName" readonly>
                </div>
              </div>
            </div>
            <div class="col-lg-7 col-md-7">
              <div class="row align-items-center form-group">
                <div class="col-md-4">
                  <label>Contact Person's No:</label>
                </div>
                <div class="col-md-8">
                  <input type="text" class="form-control" [value]="inductionProfile.alecContactPhone" readonly>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5">
              <div class="row align-items-center form-group">
                <div class="col-md-4">
                  <label>Contact Email:</label>
                </div>
                <div class="col-md-8">
                  <input type="email" class="form-control" [value]="inductionProfile.alecContactEmail" readonly>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Emergency Contact Section -->
      <div class="caption" *ngIf="inductionProfile.emergencyContactName">
        <h3 class="text-center my-3">Emergency Contact</h3>
      </div>

      <div class="row" *ngIf="inductionProfile.emergencyContactName">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-5 col-md-5">
              <div class="row align-items-center form-group">
                <div class="col-md-4">
                  <label>Emergency Contact Name:</label>
                </div>
                <div class="col-md-8">
                  <input type="text" class="form-control" [value]="inductionProfile.emergencyContactName" readonly>
                </div>
              </div>
            </div>
            <div class="col-lg-7 col-md-7">
              <div class="row align-items-center form-group">
                <div class="col-md-4">
                  <label>Emergency Contact Phone:</label>
                </div>
                <div class="col-md-8">
                  <input type="text" class="form-control" [value]="inductionProfile.emergencyContactPhone" readonly>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Validity Information -->
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-5 col-md-5">
              <div class="row align-items-center form-group">
                <div class="col-md-4">
                  <label>Issue Date:</label>
                </div>
                <div class="col-md-8">
                  <input type="text" class="form-control"
                    value="{{inductionProfile.issueDate | date:'MMM d, y hh:mm a' }}" readonly>
                </div>
              </div>
            </div>
            <div class="col-lg-7 col-md-7">
              <div class="row align-items-center form-group">
                <div class="col-md-4">
                  <label>Expiry Date:</label>
                </div>
                <div class="col-md-8">
                  <input type="text" class="form-control"
                    value="{{inductionProfile.expiryDate | date:'MMM d, y hh:mm a' }}" readonly>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Acknowledgement Button Section -->
      <div *ngIf="showAcknowledgeButton && !acknowledgementComplete && inductionProfile?.status !== 'Acknowledged'"
        class="text-center mt-4 mb-4">

        <button type="button" class="btn btn-primary btn-lg px-5" [disabled]="isAcknowledging"
          (click)="acknowledgeInduction()">
          <span *ngIf="isAcknowledging" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          <i *ngIf="!isAcknowledging" class="fas fa-check-circle me-2"></i>
          {{ isAcknowledging ? 'Processing...' : 'Acknowledge' }}
        </button>

        <div class="mt-3">
          <small class="text-muted">
            By clicking this button, you confirm that you have reviewed and approve this safety induction.
          </small>
        </div>
      </div>
    </form>
  </div>
</section>